import React from 'react'
import EventArea from '../components/EventArea'
import hipladeTemplate from '../../common/template'

function EventHome() {
  return <EventArea />
}

export default hipladeTemplate(EventHome)
